import { render, staticRenderFns } from "./HomeV2.vue?vue&type=template&id=fa1f544e&scoped=true&"
import script from "./HomeV2.vue?vue&type=script&lang=ts&"
export * from "./HomeV2.vue?vue&type=script&lang=ts&"
import style0 from "./HomeV2.vue?vue&type=style&index=0&id=fa1f544e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1f544e",
  null
  
)

export default component.exports